<template>
  <div id="app">
    <!-- 背景音乐 -->
    <div class="music" v-show="foodAudioShow" :class="{mobile:isMobile,end:isEnd}" @click="audioClick">
      <audio ref="audioMedia" src="./assets/music.mp3" id="music" loop></audio>
    </div>
    <!-- 点击音效 -->
    <audio ref="audioFood" src="./assets/food.mp3" id="music1" style="display:none;"></audio>

    <router-view />
  </div>
</template>

<script>
  import {
    isWeixin,
    IsPC
  } from "@/utils/index";
  export default {
    data() {
      return {
        isPortrait: false,
        isWx: false,
        isPc: true,
        isMobile: false,
        isEnd: false, //位置
        foodAudioPaly: true, //播放状态
        foodAudioShow: false, //隐藏音乐图标
      };
    },
    provide() {
      return {
        stop: this.stop, //视频开始音频暂停
        begin: this.begin, //音频恢复状态
        foodMusic:this.foodMusic
      }
    },
    mounted() {
      this.palyAudio()

      if (this._isMobile()) {
        this.isMobile = true
      } else {


      }
      let _this = this;
      this.isPc = IsPC();
      if (!IsPC()) {
        if (window.neworientation.current === "portrait") {
          _this.isPortrait = true;
        } else {
          _this.isPortrait = false;
        }
        // if (isWeixin() == "wx") {
        //   this.isWx = true;
        // } else {
        //   this.isWx = false;
        // }
      } else {
        _this.isPortrait = true;
      }
      let eventType =
        "onorientationchange" in window ? "orientationchange" : "resize";
      window.addEventListener(
        eventType,
        function () {
          if (!this.isPc) {
            _this.isPortrait = window.neworientation.current === "portrait";
            if (_this.isWx) {
              window.location.reload();
            }
          }
        },
        false
      );
    },
    methods: {
      _isMobile() {
        let flag = navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        );
        return flag;
      },
      // 点击音乐按钮
      audioClick() {
        if (this.foodAudioPaly == true) {
          this.pauseAudio();
        } else {
          this.palyAudio();
        }
      },
      // 播放音乐
      palyAudio() {
        this.$refs.audioMedia.play();
        this.foodAudioPaly = true
        this.isEnd = false
      },
      // 暂停音乐
      pauseAudio() {
        this.$refs.audioMedia.pause();
        this.foodAudioPaly = false
        this.isEnd = true

      },
      // 视频播放时的控制
      stop() {
        this.$refs.audioMedia.pause();
        this.foodAudioShow = false
      },
      begin() {
        if (this.foodAudioPaly == true) {
          console.log('开始播放', this.foodAudioPaly)
          setTimeout(() => {
            this.palyAudio();
            this.foodAudioShow = true

          })
        } else {
          setTimeout(() => {
            this.pauseAudio();
            this.foodAudioShow = true
          })


        }

      },
       // 播放音效
       foodMusic() {
        this.$refs.audioFood.play();
      },
    }
  };
</script>
<style lang="scss">
  .music {
    position: absolute;
    z-index: 1000;
    right: 3%;
    top: 3%;
    width: 80px;
    height: 80px;
    background: url('./assets/music-on.png') no-repeat center center/100% auto;

    &.mobile {
      top: auto;
      bottom: 3%;
      transform: scale(0.7) rotate(90deg);
    }

    &.end {
      opacity: 0.5;
    }
  }

  #app {
    // overflow: hidden;
    height: 100%;
    // width: 100%;
  }

  * {
    -webkit-touch-callout: none;
    /*系统默认菜单被禁用*/
    -webkit-user-select: none;
    /*webkit浏览器*/
    -khtml-user-select: none;
    /*早期浏览器*/
    -moz-user-select: none;
    /*火狐*/
    -ms-user-select: none;
    /*IE10*/
    user-select: none;
    -webkit-tap-highlight-color: transparent;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
  }

  img {
    -webkit-touch-callout: default;
  }

  @media screen and (orientation: portrait) {
    .main {
      -webkit-transform: rotate(-90deg);
      -moz-transform: rotate(-90deg);
      -ms-transform: rotate(-90deg);
      transform: rotate(-90deg);
      width: 100vh;
      height: 100vw;
      /*去掉overflow 微信显示正常，但是浏览器有问题，竖屏时强制横屏缩小*/
      overflow: hidden;
    }
  }

  @media screen and (orientation: landscape) {
    .main {
      -webkit-transform: rotate(0);
      -moz-transform: rotate(0);
      -ms-transform: rotate(0);
      transform: rotate(0);
    }
  }

  .mask {
    height: 100%;
    width: 100%;
    background: linear-gradient(180deg,
        rgba(0, 10, 20, 0.7) 0%,
        rgba(0, 10, 20, 0.8) 100%);
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;

    // flex-wrap: wrap;
    div {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      text-align: center;
    }

    img {
      height: 200px;
      // width: 44%;
    }
  }

  .weixin {
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;

    .bg-img {
      height: 100%;
      width: 100%;
    }

    .h-bg-img {
      height: 100%;
      width: 100%;
    }

    div {
      height: 100%;
      width: 100%;
      position: absolute;
      top: 0;
      left: 0;
      background: linear-gradient(180deg,
          rgba(0, 10, 20, 0.7) 0%,
          rgba(0, 10, 20, 0.8) 100%);

      .jt {
        height: 17.3%;
        width: 26%;
        position: absolute;
        top: 1%;
        right: 6%;
      }

      .t-text {
        color: #fff;
        height: 5.67%;
        width: 53.13%;
        position: absolute;
        font-size: 14px;
        // line-height: 14px;
        top: 18.88%;
        right: 10.8%;

        p {
          padding: 2px;
        }
      }

      .t-zd {
        height: 7.02%;
        width: 29.73%;
        position: absolute;
        top: 53%;
        left: 50%;
        transform: translate(-50%, 0);
      }

      .h-jt {
        height: 17.3%;
        width: 7.7%;
        position: absolute;
        top: 1%;
        right: 8%;
      }

      .h-t-text {
        height: 11%;
        width: 23.13%;
        position: absolute;
        color: #fff;
        top: 20%;
        right: 10%;
      }

      .h-t-zd {
        height: 15.2%;
        width: 14.73%;
        position: absolute;
        top: 63%;
        left: 50%;
        transform: translate(-50%, 0);
      }
    }
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }

  .fade-enter,
  .fade-leave-to

  /* .fade-leave-active below version 2.1.8 */
    {
    opacity: 0.3;
  }

  .fade0-enter-active,
  .fade0-leave-active {
    transition: opacity 0.3s;
  }

  .fade0-enter,
  .fade0-leave-to

  /* .fade-leave-active below version 2.1.8 */
    {
    opacity: 0.3;
  }

  .fade1-enter-active,
  .fade1-leave-active {
    transition: opacity 2s;
  }

  .fade1-enter,
  .fade1-leave-to

  /* .fade-leave-active below version 2.1.8 */
    {
    opacity: 0;
  }

  .fade4-enter-active,
  .fade4-leave-active {
    transition: opacity 4s;
  }

  .fade4-enter,
  .fade4-leave-to

  /* .fade-leave-active below version 2.1.8 */
    {
    opacity: 0;
  }

  .fade2-enter-active,
  .fade2-leave-active {
    transition: opacity 5s;
  }

  .fade2-enter,
  .fade2-leave-to

  /* .fade-leave-active below version 2.1.8 */
    {
    opacity: 0;
  }
</style>